/* =========================

  Header and Loading

============================ */
import styled from "styled-components";
import {break_point_sp} from "../../Styled/mixin";

// import React, { useState, useEffect } from 'react';

/* -------------------------

  component

---------------------------- */
function Header( props ) {
  // const [loadFlag, setFlag] = useState(0);

  // useEffect(() => {
  //   setFlag(1)
  // },[])

  return (
    <>
    <Styled className="l-header">
      <div className="l-header__inner l-inner--1100 l-inner--92">

        <div className="l-header__block__01 l-header__block">
          <div className="l-header__block__inner">

            <div className="l-header__box">
              <div className="l-header__box__inner">
                <p><a href="/"><img src={`${process.env.PUBLIC_URL}/assets/img/common/logo.png`} alt="健康家族" /></a></p>
              </div>
            </div>

          </div>
        </div>

        <div className="l-header__block__02 l-header__block">
          <div className="l-header__block__inner">

            <div className="l-header__box">
              <div className="l-header__box__inner">
                <p className="l-header__txt_title c-font_f--km">
                  <span><img src={`${process.env.PUBLIC_URL}/assets/img/common/icn_diagnoise.png`} alt="" /></span>
                  あなたにピッタリの商品は？
                </p>
              </div>
            </div>

          </div>
        </div>

      </div>
    </Styled>


    {/* <StyledLoading id="loading" className={`${(loadFlag!==0)?"isFadeOut":""}`}>
      <p>ローディングエリア</p>
    </StyledLoading> */}

    </>
  );
}

export default Header;

/* -------------------------

  styled

---------------------------- */
const Styled = styled.header`
  background: #ffffff;
  padding: 15px 0;
  .l-header__inner{
    display: grid;
    grid-template-columns: 0.5fr 3fr 0.5fr;
    grid-template-rows: 1fr;
  }

  .l-header__block__01{
    grid-column: 1;
    grid-row: 1;
    /* .l-header__block__inner{
      height: 100%;
    } */
    .l-header__box{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      /* height: 100%; */
    }
  }

  .l-header__block__02{
    grid-column: 2;
    grid-row: 1;
    .l-header__box{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      /* height: 100%; */

      .l-header__txt_title{
        font-size: 30px;
        color: #451700;
        position: relative;
        letter-spacing: 0.1em;
        span{
          display: inline-block;
          width: 1.3em;
          img{
            width: 100%;
            vertical-align: middle;
          }
        }
        &::before{
          content: "＼";
          display: inline-block;
          font-size: 1em;
        }
        &::after{
          content: "／";
          display: inline-block;
          font-size: 1em;
        }
      }
    }
  }

	@media ${break_point_sp} {
    .l-header__inner{
      display: block;
    }
    .l-header__block__01{
      .l-header__box{
        display: block;
        width: calc((300/750)*100%);
        img{
          width: 100%;
        }
      }
    }
    .l-header__block__02{
      margin-top: 5px;
      .l-header__box{
        .l-header__txt_title{
          font-size: calc((42/750)*100vw);
          letter-spacing: 0;
        }
      }
    }
	}
`;

// const StyledLoading = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background: #cccccc;
//   z-index: 3;
// 	@media ${break_point_sp} {
// 	}
// `;
